module.exports = __webpack_public_path__ + "img/icons BFr_17.a344b321.png";